import * as $ from 'jquery';
import 'select2';
import "select2/dist/js/i18n/pt-BR.js";
import 'select2/dist/css/select2.min.css'; 

export default (function () {

    window.select2Options = {
        "language": "pt-BR",
    }

    $(".select2").select2(window.select2Options);
    
    $('.select2-tag').select2({
        tags: true,
        tokenSeparators: [','],
    });

    $('fieldset[disabled] select').prop('disabled', true);
}())
